import * as React from "react";
import { useLocalization } from "gatsby-theme-i18n";
import { Link } from "gatsby";

const altLang = "en";

const LangChange = ({ originalPath, ...props }) => {
  const { locale, defaultLang } = useLocalization();

  if (!originalPath) {
    originalPath = "/";
  }

  if (locale === defaultLang) {
    return (
      <Link to={`/${altLang}` + originalPath.replace(/\/$/, "")} {...props}>
        EN
      </Link>
    );
  } else {
    if (originalPath === "/") {
      return (
        <Link to={"/"} {...props}>
          中
        </Link>
      );
    }
    return (
      <Link to={originalPath.replace(/\/$/, "")} {...props}>
        中
      </Link>
    );
  }
};

export default LangChange;
